/**
 * @generated SignedSource<<e723fa35218cdf6973ce1a5a8189dcdb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditOnPercentagePassContentConfigInput = {
  clientMutationId?: string | null | undefined;
  configId: string;
  contentNodeId: string;
  newRequiredPercentage: number;
};
export type OnPercentagePassContentConfigForm_EditMutation$variables = {
  input: EditOnPercentagePassContentConfigInput;
};
export type OnPercentagePassContentConfigForm_EditMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly editOnPercentagePassContentConfig: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"PassContentConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type OnPercentagePassContentConfigForm_EditMutation = {
  response: OnPercentagePassContentConfigForm_EditMutation$data;
  variables: OnPercentagePassContentConfigForm_EditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OnPercentagePassContentConfigForm_EditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditOnPercentagePassContentConfigPayload",
                "kind": "LinkedField",
                "name": "editOnPercentagePassContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PassContentConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnPercentagePassContentConfigForm_EditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditOnPercentagePassContentConfigPayload",
                "kind": "LinkedField",
                "name": "editOnPercentagePassContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "passConfig",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "requiredPercentage",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "OnPercentagePassContentConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f499ddbc55f49f9459eba54e5b2391a8",
    "id": null,
    "metadata": {},
    "name": "OnPercentagePassContentConfigForm_EditMutation",
    "operationKind": "mutation",
    "text": "mutation OnPercentagePassContentConfigForm_EditMutation(\n  $input: EditOnPercentagePassContentConfigInput!\n) {\n  Admin {\n    Tree {\n      editOnPercentagePassContentConfig(input: $input) {\n        contentNode {\n          ...PassContentConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment OnPercentagePassContentConfigForm_OnPercentagePassContentConfigFragment on OnPercentagePassContentConfig {\n  id\n  configType\n  requiredPercentage\n}\n\nfragment OnPercentagePassContentConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment PassContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      passConfig {\n        __typename\n        configType\n        ... on OnPercentagePassContentConfig {\n          requiredPercentage\n        }\n        ...OnPercentagePassContentConfigForm_OnPercentagePassContentConfigFragment\n        id\n      }\n    }\n  }\n  ...OnPercentagePassContentConfigForm_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "0cfc823ebfb843d6af938c7b7999e37b";

export default node;
